// 表单组件原生支持校验的格式
// 文档地址：https://github.com/yiminghe/async-validator#type
// 原生使用示例：
// var descriptor = {
//   role: {type: "enum", enum: ['admin', 'menu', 'guest']}
// }
// userName: [
//             {required: true, message: '用户名不能为空'},
//             {type: "enum", enum: ['admin', 'menu', 'guest']}
//           ],
// string: Must be of type string. This is the default type.
// number: Must be of type number.
// boolean: Must be of type boolean.
// method: Must be of type function.
// regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
// integer: Must be of type number and an integer.
// float: Must be of type number and a floating point number.
// array: Must be an array as determined by Array.isArray.
// object: Must be of type object and not Array.isArray.
// enum: Value must exist in the enum.
// date: Value must be valid as determined by Date
// url: Must be of type url.
// hex: Must be of type hex.
// email: Must be of type email.
// any: Can be any type.
// 扩展使用示例：
// userName: [
//             {required: true, message: '用户名不能为空'},
//             {required: true, validator: this.$validate.validateMobile}
//           ],

/**
 * 手机号码格式校验
 * @param rule
 * @param value
 * @param callback
 */
export const validateMobile = (rule, value, callback) => {
    const tel = /^0\d{2,3}-?\d{7,8}$/;
    const reg = /^1\d{10}$/;
    if (value !== '' && (!reg.test(value) && !tel.test(value))) {
        callback(new Error('联系方式不正确(固话需带区号,使用 - 将区号与号码隔开)'));
    } else {
        callback();
    }
};

/**
 * 只能输入数字格式校验
 * @param rule
 * @param value
 * @param callback
 */
export const validateNumber = (rule, value, callback) => {
    const reg = /^[0-9]*$/;
    if (value !== '' && !reg.test(value)) {
        callback(new Error('只能输入数字'));
    } else {
        callback();
    }
};

/**
 * 输入金额0-99999.99
 * @param rule
 * @param value
 * @param callback
 */
export const validateMoney = (rule, value, callback) => {
    const reg = /^\d{1,5}(\.\d{1,2})?$/;
    if (value !== '' && !reg.test(value)) {
        callback(new Error('请输入0-99999.99之间的数字'));
    } else {
        callback();
    }
};

/**
 * 固定电话格式校验
 * @param rule
 * @param value
 * @param callback
 */
export const validatePhone = (rule, value, callback) => {
    const reg = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
    if (value !== '' && !reg.test(value)) {
        callback(new Error('固定电话格式不正确'));
    } else {
        callback();
    }
};

/**
 * 校验身份证的有效性
 * @param value
 */
const validateIdCardFunc = (value) => {
    // 1 "验证通过!", 0 //校验不通过
    const format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
    // 号码规则校验
    if (!format.test(value)) {
        return { status: 0, msg: '身份证号码不合规' };
    }
    // 区位码校验
    // 出生年月日校验   前正则限制起始年份为1900;
    const year = value.substr(6, 4);
    // 身份证年
    const month = value.substr(10, 2);
    // 身份证月
    const date = value.substr(12, 2);
    // 身份证日
    const time = Date.parse(`${month}-${date}-${year}`);
    // 身份证日期时间戳date
    const nowTime = Date.parse(new Date());
    // 当前时间戳
    const dates = (new Date(year, month, 0)).getDate();
    // 身份证当月天数
    if (time > nowTime || date > dates) {
        return { status: 0, msg: '出生日期不合规' };
    }
    // 校验码判断
    // 系数
    const c = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    // 校验码对照表
    const b = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    const idArray = value.split('');
    let sum = 0;
    for (let k = 0; k < 17; k++) {
        sum += window.parseInt(idArray[k]) * window.parseInt(c[k]);
    }
    if (idArray[17].toUpperCase() !== b[sum % 11].toUpperCase()) {
        return { status: 0, msg: '身份证校验码不合规' };
    }
    return { status: 1 };
};

/**
 * 身份证格式校验
 * @param rule
 * @param value
 * @param callback
 */
export const validateIdCard = (rule, value, callback) => {
    const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (value !== '' && !reg.test(value)) {
        callback(new Error('身份证位数不足，位数区间15-18'));
        return;
    }
    const res = validateIdCardFunc();
    if (res.state === 0) {
        callback(new Error(res.msg));
    }

    callback();
};

/**
 * 只是一个单纯的提示
 */
export const agreement = (rule, value, callback) => {
    callback(new Error('协议编号重复请重新输入!'));
};
